import React from 'react';
import { Container } from './styled';
import { ReactComponent as Loading } from '@meindach/ui-kit/dist/assets/loading/loading.svg';

export const PageLoading = () => (
  <Container>
    <Loading />
  </Container>
);
